import Chart from "common/components/Chart/Chart";
import { useColumnsChart } from "hooks/chart/UseColumnsChart";
import React, { useEffect } from "react";
import { MOREGRAPH } from "utils/constants";

const ColumnsChart = ({ data, xAxis, yAxis }) => {
    const {
        options: optionsColumnsChart,
        setOptions: setOptionsColumnsChart,
        showLoading,
        hideLoading,
    } = useColumnsChart();

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            showLoading();

            setTimeout(() => {
                const dataFiltered = [];

                data.value_categories.forEach((serieName) => {
                    dataFiltered.push({
                        name: serieName,
                        data: data.group_by_categories.map((cat) => {
                            const match = data.data.find(
                                (obj) =>
                                    obj[`group_by_${xAxis}_${yAxis}`][xAxis] === serieName &&
                                    obj[`group_by_${xAxis}_${yAxis}`][yAxis] === cat
                            );
                            return match ? match.count : null;
                        }),
                    });
                });

                // 🔹 Filtrar categorías sin datos
                const filteredCategories = [];
                const filteredDataPerSeries = dataFiltered.map(() => []);

                data.group_by_categories.forEach((cat, idx) => {
                    const hasValue = dataFiltered.some((serie) => serie.data[idx] > 0);
                    if (hasValue) {
                        filteredCategories.push(cat);
                        dataFiltered.forEach((serie, sIdx) => {
                            filteredDataPerSeries[sIdx].push(serie.data[idx]);
                        });
                    }
                });

                // Aplicar los datos filtrados
                const finalSeries = dataFiltered.map((serie, idx) => ({
                    ...serie,
                    data: filteredDataPerSeries[idx],
                }));

                setOptionsColumnsChart({
                    ...optionsColumnsChart,
                    xAxis: {
                        ...optionsColumnsChart.xAxis,
                        categories: filteredCategories,
                    },
                    series: finalSeries,
                });

                hideLoading();
            }, 100);
        } else {
            setOptionsColumnsChart({
                ...optionsColumnsChart,
                series: [
                    {
                        ...optionsColumnsChart.series[0],
                        data: [],
                    },
                ],
            });
        }
    }, [data]);

    return (
        <Chart
            options={optionsColumnsChart}
            type={MOREGRAPH}
            onChartReady={(chart) => {
                showLoading.chartRef = chart;
            }}
        />
    );
};

export default ColumnsChart;
